import React from 'react';
import { Redirect } from 'react-router-dom';
import './CabecalhoSelecao.css';

import Auth from '../services/Auth';
import * as ROUTES from '../constants/routes';

const logo = require('../assets/logos/LOGOMBTC1_Prancheta_1.png');

export default class Cabecalho extends React.Component {
  constructor(props) {
    super(props);
    const { mensagem } = props;
    this.state = {
      cadastrar: false,
      msg: mensagem,
    };
  }

  componentDidUpdate(prevProps) {
    const { mensagem } = this.props;
    if (prevProps.mensagem !== mensagem) {
      this.executarMensagem(mensagem);
    }
  }

  async executarMensagem(mensagem) {
    await this.setState({ msg: mensagem });
    await setTimeout(async () => {
      await this.setState({ msg: '' });
    }, 5000);
  }

  navegarCadastro() {
    this.setState({ cadastrar: true });
  }

  sair() {
    Auth.sair();
  }

  render() {
    const { acompanhamento = false, administrador = false, usuario = '', titulo } = this.props;
    const { cadastrar, msg } = this.state;

    if (cadastrar) {
      return <Redirect to={ROUTES.CADASTRAR} />;
    }

    if (acompanhamento) {
      return (
        <div className="CabecalhoSelecao-header">
          <div className="Logo">
            <img alt="Minas Brasília Tênis Clube" className="LogoImg" width="1754" height="1905" src={logo} />
          </div>
          <div className="Acompanhamento">
            <h1>{titulo}</h1>
            {msg !== '' ? (
              <div className="Acompanhamento-Msg">
                <h5>{msg}</h5>
              </div>
            ) : null}
          </div>
          <div className="Sair" />
        </div>
      );
    }
    return (
      <div className="CabecalhoSelecao-header">
        <div className="Logo">
          <img alt="Minas Brasília Tênis Clube" className="LogoImg" width="1754" height="1905" src={logo} />
        </div>
        <div className="TituloSelecao">
          <h1>{titulo}</h1>
        </div>
        <div className="Sair">
          {/* <p>{usuario}</p>
          {administrador ? <button onClick={() => this.navegarCadastro()}>Criar Contas</button> : null} */}
          <button onClick={() => this.sair()}>Sair</button>
        </div>
      </div>
    );
  }
}
